export const UPDATE = 'redirect/UPDATE'

export function updateRedirect(pathname: string): any {
  return { type: UPDATE, pathname }
}
